import styled, { css } from 'styled-components';
import { DeprecatedIcon as Icon } from '@aon-coverwallet/cw-react-components';
import { SmartLink } from 'src/components/common/smartComponents';

const mobileMenuWidth = '250px;';

export const StyledMobileMenu = styled.div(
  ({ theme: { sizes } }) => css`
    display: none;

    @media (max-width: ${sizes.tablet}) {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
    }
  `,
);

export const StyledTrigger = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  padding: 9px;
  font-size: 12px;
  color: ${({ theme: { colors } }) => colors.white};
`;

export const StyledIconTrigger = styled(Icon)`
  font-size: 25px;
  line-height: 1em;
  cursor: pointer;
`;

export const StyledMobileMenuBody = styled.div(
  ({ visible, theme: { colors } }) => css`
    position: fixed;
    z-index: 999;
    top: 0;
    left: ${visible ? 0 : '-'.concat(mobileMenuWidth)};
    width: ${mobileMenuWidth};
    height: 100vh;
    color: ${colors.white};
    background-color: ${colors.brand.primary.default} !important;
    transition: all 0.2s linear;
    word-break: break-all;
  `,
);

export const StyledCancelTrigger = styled(StyledTrigger)`
  padding: 20px 20px 12px;
`;

export const StyledInfoContainer = styled.div`
  padding: 15px;
  margin-bottom: 10px;
  border-bottom: 1px solid
    ${({ theme: { colors } }) => colors.brand.primary.light} !important;
`;

export const StyledPrimaryInfo = styled.div`
  margin-bottom: 5px;
  font-size: 14px;
`;

export const StyledSecondaryInfo = styled.div`
  font-size: 12px;
  color: ${({ theme: { colors } }) => colors.brand.secondary.extraLight};
`;

export const StyledLink = styled(SmartLink)`
  display: flex;
  align-items: center;
  color: ${({ theme: { colors } }) => colors.white};
  font-size: 13px;
  padding: 8px 15px;
  &:hover {
    background-color: ${({ theme: { colors } }) =>
      colors.headerHoverColor} !important;
    color: ${({ theme: { colors } }) => colors.white};
  }
  &:before {
    font-size: 20px;
  }

  ${({ logout }) =>
    logout &&
    css`
      position: absolute;
      bottom: 25px;
    `};
`;

export const StyledIconAction = styled(Icon)`
  margin-right: 7px;

  g {
    path:nth-child(2) {
      fill: white;
      fill-opacity: 1;
    }
  }
`;

export const StyledImg = styled.img`
  height: 20px;
  padding-right: 7px;
`;

export const StyledLabel = styled.span`
  height: 28px;
  line-height: 28px;
`;
